import React from "react";
import { Link } from "gatsby";
import { Container, Stack, styled, Typography, Link as MuiLink } from '@mui/material';

const Root = styled('div')({
  marginTop: 50,
  backgroundColor: '#1b1b1b',
  padding: '16px 32px',
  minHeight: 80,
  display: 'flex',
  alignItems: 'center',
});

const Footer: React.FC = () => {
  return (
    <Root>
      <Container maxWidth="lg">
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="caption">
            © 2021-2022 HayApe
          </Typography>
          <Stack direction={{ 'xs': 'column', md: 'row' }} spacing={{xs: 0, md: 2}}>
            <MuiLink component={Link} to="/terms">
              Terms & Conditions
            </MuiLink>
            <MuiLink component={Link} to="/privacy">
              Privacy Policy
            </MuiLink>
          </Stack>
        </Stack>
      </Container>
    </Root>
  );
};

export default Footer;